import { useState, useEffect } from "react"
import { FiRefreshCw } from "react-icons/fi"
import { TbListSearch } from "react-icons/tb"
//css
import './modalFormServiceExpiration.css'

import FormRegisterInfo from "./FormRegisterInfo"
import FormRegisterEvent from "./FormRegisterEvent"
import FormRegisterEquipmentSanitization from "./FormRegisterEquipmentSanitization"
import api from '../../../../utils/api'
import FormEvent from "./FormEvent"
import Modal from "../../../../shared/modal/Modal"
import FormLayout from "../../../../shared/components/FormLayout/FormLayout"
import Button from "../../../../shared/components/Button/Button"
/* Hooks */
import useFlashMessage from '../../../../hooks/useFlashMessage'
import FormRegisterHorimetro from "./FormRegisterHorimetro"
import useMyPermission from '../../../../hooks/useMyPermission'

function ModalFormServiceExpiration({ updateData, clientData, listClient, closeModal, myPermission }) {

    const [token] = useState(localStorage.getItem('token') || '')

    const { setFlashMessage } = useFlashMessage()


    //CHECK PERMISSIONS
    const { checkPermission } = useMyPermission()
    const myPermissionCreate = checkPermission(myPermission, "serviceExp_Create")
    const [modalEvent, setModalEvent] = useState(false)


    let clientInfo = {}
    function updateInfo() {
        let filter = listClient.filter((i) => i._id === clientData._id)
        clientInfo = filter[0]


    }

    function reflesh() {
        updateData()
    }
    async function registerEvent(info) {
        let msgType = 'success'
        let obj = {
            ...info,
            client: clientData._id
        }
        const data = await api.post('/event/new', obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        }).then((response) => {

            updateData()
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })
        setFlashMessage(data.message, msgType)
        return msgType

    }


    async function registerRadiatorRecordDate(info) {
        let msgType = 'success'
        let obj = {
            ...info,
            client: clientData._id
        }
        const data = await api.post('/radiator/new', obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        }).then((response) => {

            updateData()
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })
        setFlashMessage(data.message, msgType)
        return msgType
    }
    async function registerEquipmentSanitizationDate(info) {
        let msgType = 'success'
        let obj = {
            ...info,
            client: clientData._id
        }
        const data = await api.post('/equipmentSanitization/new', obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        }).then((response) => {

            updateData()
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })
        setFlashMessage(data.message, msgType)
        return msgType
    }
    async function registerAlternatorMegageDate(info) {
        let msgType = 'success'
        let obj = {
            ...info,
            client: clientData._id
        }

        const data = await api.post('/alternatorMegage/new', obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        }).then((response) => {

            updateData()
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })
        setFlashMessage(data.message, msgType)
        return msgType
    }
    async function registerInjectionPumpRecordDate(info) {
        let msgType = 'success'
        let obj = {
            ...info,
            client: clientData._id
        }

        const data = await api.post('/injectionPump/new', obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        }).then((response) => {

            updateData()
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })
        setFlashMessage(data.message, msgType)
        return msgType
    }
    async function registerTankCleaningRecordDate(info) {
        let msgType = 'success'
        let obj = {
            ...info,
            client: clientData._id
        }
        const data = await api.post('/tankCleaning/new', obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        }).then((response) => {

            updateData()
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })
        setFlashMessage(data.message, msgType)
        return msgType
    }
    async function registerChangeBatteryRecordDate(info) {
        let msgType = 'success'
        let obj = {
            ...info,
            client: clientData._id
        }
        const data = await api.post('/changeBattery/new', obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        }).then((response) => {

            updateData()
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })
        setFlashMessage(data.message, msgType)
        return msgType
    }

    const registerHorimetroRecord = async (info) => {
        let msgType = 'success'
        let obj = {
            ...info,
            client: clientData._id
        }

        const data = await api.post('/horimetro/new', obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`
            }
        }).then((response) => {

            updateData()
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })
        setFlashMessage(data.message, msgType)
        return msgType
    }




    updateInfo()
    return (
        <Modal
            modalStatus={true}
            changeStatus={closeModal}
            w={90}
            content={
                <FormLayout
                    title={clientData.name}
                    actions={
                        <>
                            <Button variant="edit" icon={TbListSearch} onClick={() => { window.open(`/horimetro/edit/${clientData._id}`, '_blank') }}>Detalhes</Button>
                            <Button variant="select" icon={FiRefreshCw} onClick={() => { reflesh() }}>Atualizar</Button>
                        </>
                    }
                >
                    <div className="modal-form-service-expiration-list">

                        <FormRegisterEvent lastDid={clientInfo.lastEventDate} name={clientInfo.lastEventName} description={clientInfo.lastEventDescription} handleOnSubmit={registerEvent} permission_create={myPermissionCreate} />
                        <FormRegisterInfo title={"Radiador Sist. Arr.:"} lastDid={clientInfo.lastInspectionRadiatorDate} NextToDo={clientInfo.nextInspectionRadiatorDate} handleOnSubmit={registerRadiatorRecordDate} permission_create={myPermissionCreate} />
                        <FormRegisterInfo title={"Revião de Bomba Injetora:"} lastDid={clientInfo.lastInspectionInjectionPumpDate} NextToDo={clientInfo.nextInspectionInjectionPumpDate} handleOnSubmit={registerInjectionPumpRecordDate} permission_create={myPermissionCreate} />
                        <FormRegisterInfo title={"Limpeza de Tanque:"} lastDid={clientInfo.lastTankCleaningDate} NextToDo={clientInfo.nextTankCleaningDate} handleOnSubmit={registerTankCleaningRecordDate} permission_create={myPermissionCreate} />
                        <FormRegisterInfo title={"Troca de Bateria:"} lastDid={clientInfo.lastChangeBatteryDate} NextToDo={clientInfo.nextChangeBatteryDate} handleOnSubmit={registerChangeBatteryRecordDate} permission_create={myPermissionCreate} />
                        <FormRegisterInfo title={"Megagem de Alternador:"} lastDid={clientInfo.lastAlternatorMegageDate} NextToDo={clientInfo.nextAlternatorMegageDate} handleOnSubmit={registerAlternatorMegageDate} permission_create={myPermissionCreate} />
                        <FormRegisterInfo NextToDoByUser={true} title={"Higienização de Equipamento:"} lastDid={clientInfo.lastEquipmentSanitizationDate} NextToDo={clientInfo.nextEquipmentSanitizationDate} handleOnSubmit={registerEquipmentSanitizationDate} permission_create={myPermissionCreate} />

                        <FormRegisterHorimetro
                            lastHorimetroDate={clientInfo.lastHorimetroDate}
                            lastHorimetroRecord={clientInfo.lastHorimetroRecordSeconds}
                            lastHorimetroChangeOilAndFilterDate={clientInfo.lastHorimetroChangeOilAndFilterDate}
                            lastHorimetroChangeOilAndFilterRecord={clientInfo.lastHorimetroChangeOilAndFilterRecordSeconds}
                            nextHorimetroChangeOilAndFilterDate={clientInfo.nextHorimetroChangeOilAndFilterDate}
                            totalLastHorimetroChangeOilAndFilterRecord={clientInfo.totalLastHorimetroChangeOilAndFilterRecordSeconds}
                            nextHorimetroDate={clientInfo.nextHorimetroDate}
                            handleOnSubmit={registerHorimetroRecord}
                            permission_create={myPermissionCreate}

                        />
                    </div>
                </FormLayout>
            }
        />

    )

}
export default ModalFormServiceExpiration